<script lang="ts">
  import Select from '@smui/select';
  import { createEventDispatcher } from 'svelte';
  import { getStr, globalCurrencyTag, isMobileWidth } from '../../../../common/util';
  import { formatPrice } from '../../../brand/services/brand-data-services';
  import { brandActiveFilters, selectedPriceFilter } from '../../../brand/store/brand_store';
  import ExtraCheckBox from '../../components/ExtraCheckBox.svelte';
  import ExtraFormField from '../../components/ExtraFormField.svelte';
  import Text from '../../components/Text.svelte';

  const dispatcher = createEventDispatcher();
  export let options;
  let valueHelperText = '';
  export let label = '';
  function handleClick(e, data) {
    console.log(e, 'e');
    console.log(data, 'data');
    let rangeStart = data[0];
    let rangeEnd = data[data.length - 1];
    let priceFilterLabel = getStr('brand.price.range', [globalCurrencyTag, +rangeStart, +rangeEnd]);
    if (e.target.checked) {
      if (!$brandActiveFilters.includes(priceFilterLabel)) {
        brandActiveFilters.update(x => {
          x = [...$brandActiveFilters, priceFilterLabel];
          return x;
        });
      }
    } else {
      $brandActiveFilters = $brandActiveFilters.filter(item => item !== priceFilterLabel);
    }
    dispatcher('priceFilterClicked', { rangeStart, rangeEnd });
  }

  function selectClosing() {
    if (isMobileWidth()) {
      const ele: any = document.getElementsByClassName('filter-container')[0];
      ele.style.overflowX = 'scroll';
    }
  }

  function selectOpen(_e) {
    if (isMobileWidth()) {
      const ele: any = document.getElementsByClassName('filter-container')[0];
      ele.style.overflowX = 'clip';
    }
  }
</script>

<section class="filter-tag-container">
  <div class="columns margins">
    <div>
      <Select
        class="shaped-outlined"
        variant="outlined"
        bind:value={valueHelperText}
        {label}
        on:SMUIMenuSurface:closing={selectClosing}
        on:SMUIMenuSurface:opened={selectOpen}
      >
        {#each options as option}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <ExtraFormField>
            <div
              on:click={e => {
                handleClick(e, option);
              }}
            >
              <ExtraCheckBox
                bind:bindGroup={$selectedPriceFilter}
                value={`${+option[0]} - ${+option[option.length - 1]}`}
              />
            </div>
            <span slot="label"
              ><Text
                key="brand.price.range"
                args={[
                  `${globalCurrencyTag}`,
                  `${formatPrice(option[0])}`,
                  `${formatPrice(option[option.length - 1])}`,
                ]}
              /></span
            >
          </ExtraFormField>
        {/each}
      </Select>
    </div>
  </div>
</section>

<style lang="scss">
  @import '../../styles/colors.new.scss';

  .filter-tag-container {
    * :global(.shaped-outlined),
    * :global(.shaped-outlined .mdc-select__anchor) {
      border-radius: 28px;
      height: 42px;
      background: $secondary-gray-02;
      z-index: 2;
    }
    * :global(.shaped-outlined .mdc-text-field__input) {
      padding-left: 32px;
      padding-right: 0;
    }
    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__leading) {
      border-radius: 28px 0 0 28px;
      width: 20px;
      border-right: none;
      border-left: 1px solid rgba(0, 0, 0, 0.38);
    }
    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__trailing) {
      border-radius: 0 28px 28px 0;
      border-right: 1px solid rgba(0, 0, 0, 0.38);
      border-left: none;
    }
    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__notch) {
      max-width: calc(100% - 28px * 2);
    }
    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__notch .mdc-floating-label) {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      color: $neutral-dark-01;
    }
    *
      :global(
        .shaped-outlined.mdc-select--with-leading-icon
          .mdc-notched-outline:not(.mdc-notched-outline--notched)
          .mdc-floating-label
      ) {
      left: 16px;
    }
    * :global(.shaped-outlined .mdc-select__menu .mdc-deprecated-list div) {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      color: $neutral-dark-02;
      height: 20px;
    }

    * :global(.mdc-select--outlined .mdc-menu-surface) {
      border-radius: 10px;
      border: 1px solid $secondary-gray-02;
      background: $primary-white;
      width: 224px;
      box-shadow: 0px 4px 12px 0px rgba(219, 227, 232, 0.6);
      top: 56px !important;
    }
    * :global(.mdc-deprecated-list) {
      display: inline-flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      width: 100%;
      margin-top: 20px;
    }

    * :global(.mdc-select--focused .mdc-menu-surface--open) {
      display: inline-table;
      z-index: 2;
    }

    * :global(.mdc-select .mdc-select__menu .mdc-deprecated-list-item) {
      background-color: white;
    }
  }
</style>
